/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.ingest.defs";

export { $nsid };

/** An ingest URL for a Streamplace station. */
type Ingest = { $type?: "place.stream.ingest.defs#ingest";

  /**
   * The type of ingest endpoint, currently 'rtmp' and 'whip' are supported.
   */
  "type":string;

  /**
   * The URL of the ingest endpoint.
   */
  "url":l.UriString };

export type { Ingest };

/** An ingest URL for a Streamplace station. */
const ingest = /*#__PURE__*/ l.typedObject<Ingest>($nsid, "ingest", /*#__PURE__*/ l.object({"type":/*#__PURE__*/ l.string(),"url":/*#__PURE__*/ l.string({"format":"uri"})}));

export { ingest };
